import { createDecorator, CoreDecorator, Type } from '../../core/decorators';
import { RouteConfig } from './interfaces';

export interface Route {
    path: string;
    method: string | string[];
    config?: RouteConfig;
    providers?: Array<Type<any>|any>;
    labels?: string | string[];
}
export const Route: CoreDecorator<Route> = createDecorator<Route>('Route', {
    path: undefined,
    method: undefined,
    config: undefined,
    providers: undefined,
    labels: undefined
});

export interface Lifecycle {
    event: string;
}
export const Lifecycle: CoreDecorator<Lifecycle> = createDecorator<Lifecycle>('Lifecycle', {
    event: undefined
});
